import { useAuthStore } from "~/stores/auth";

export default defineNuxtRouteMiddleware(async (to) => {
    const authStore = useAuthStore();
    const {
        isDealerPortal
    } = usePortalTerminology(to);
    const code = (to.query.code as string) || null;
    const publicPages = ["/error", "/expired", "/signed-out", "/404"];
    const environments = ["development", "testing"];

    // Redirect to 404 page if route doesn't exist
    if (to.matched.length === 0) {
        return navigateTo('/404');
    }

    // Allow access to public pages
    if (publicPages.includes(to.path)) {
        return;
    }

    if (to.path == "/" && code) {
        return;
    }

    let checkAuth = true;

    if (environments.includes(process.env.NODE_ENV) && useRuntimeConfig().public.skipAuth === true) {
        checkAuth = false;
    }

    // Check if user is authenticated
    if (checkAuth) {
        if (authStore.isLoginExpired()) {
            const loginStatus = await authStore.refreshLogin();
            if (!loginStatus) {
                if (to.path !== "/") {
                    return navigateTo("/expired");
                } else {
                    return;
                }
            }
        }
    }

    if (to.path == "/") {
        if (isDealerPortal) {
            return navigateTo("/dealer/dashboard");
        }

        return navigateTo("/dashboard");
    }
});
